<template>
    <v-snackbar
        app
        v-model="on"
        bottom
        :timeout="5000"
        :color="color">
        <v-flex class="d-flex align-center justify-space-between">
            <div>{{ message }}</div>
            <v-btn text @click="on = false" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-flex>
    </v-snackbar>
</template>
<script>
export default {
name: 'BeeSnackbar',
data: () => ({
    on: false,
    message: "null",
    color: "#aa0003"
}),

methods: {
    show(message) {
        this.color = "#aa0003"
        this.message = message;
        this.on = true;
    },
    notify(message) {
        this.color = "teal"
        this.message = message;
        this.on = true;
    },
    hide() {
        this.on = false;
    }
}
}
</script>
